<template>
  <div>
    <img class="imgs" src="../../assets/agencyReseller.jpg" alt="">
  </div>
</template>
<script>
export default {
  name: "App",
  components: {
  },
  data() {
    return {
    };
  },
  created() {
    document.title = 'وكلاء الشحن'
  },
  mounted() {
  },
  methods: {
  },
};

</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>